module.exports = __webpack_public_path__ + "img/dynamic-logo-mark.9eb29435.png";